import axios from 'axios'

export const getBookmark = () => {
  return axios.get('bookmark')
    .then(res => {
      let result = {}
      result.data = res.data.results
      return result
    })
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const addBookmark = (data) => {
  return axios.post('bookmark', data)
    .then(res => res)
    .catch(err => {
      console.log('dor', err)
      throw err.response
    })
}

export const removeBookmark = ({quoteId, createAt}) => {
  return axios.delete(`bookmark/${quoteId}/${createAt}`)
    .then(res => res)
    .catch(err => {
      console.log('dor', err)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/bookmark.api.js